import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("wa_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err.response?.data?.detail || "";
    const blocked = err.response?.status === 403 && typeof d === "string" && /pending Super Admin approval|registration was rejected|company account is disabled|company account has been deleted|suspended/i.test(d);
    if (err.response?.status === 401 || blocked) {
      localStorage.removeItem("wa_token");
      if (blocked) sessionStorage.setItem("blocked_msg", d);
      if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
